<template>
    <form id="contact-form" method="post" @submit.prevent="contactFormSubmit">  
        <span class="input input--nao">
            <input class="input__field input__field--nao" type="text" v-model.trim="$v.formData.name.$model" placeholder="Full Name"/>
            <svg class="graphic graphic--nao" :class="($v.formData.name.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
            </svg>            
        </span>
        <p class="form-error" v-if="$v.formData.name.$error && !$v.formData.name.required">Please Enter your name!</p>
        <p class="form-error" v-if="$v.formData.name.$error && !$v.formData.name.minLength">Name must have at least {{$v.formData.name.$params.minLength.min}} letters.!</p>

        <span class="input input--nao">
            <input class="input__field input__field--nao" type="email" v-model.trim="$v.formData.email.$model" placeholder="Email"/>
            <svg class="graphic graphic--nao" :class="($v.formData.email.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
            </svg>
        </span>
        <p class="form-error" v-if="$v.formData.email.$error && !$v.formData.email.required">Please Enter your email!</p>
        <p class="form-error" v-if="$v.formData.email.$error && !$v.formData.email.email">Invalid Email Address!</p>

        <span class="input input--nao">
            <input class="input__field input__field--nao" type="tel" v-model.trim="$v.formData.phone.$model" placeholder="Phone"/>
            <svg class="graphic graphic--nao" :class="($v.formData.phone.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
            </svg>
        </span>
        <p class="form-error" v-if="$v.formData.phone.$error && !$v.formData.phone.required">Please Enter your phone Number!</p>
        <p class="form-error" v-if="$v.formData.phone.$error && !$v.formData.phone.numeric">Invalid Phone Number!</p>
        <!-- <p class="form-error" v-if="$v.formData.phone.$error && !$v.formData.phone.minLength">Phone Number must be {{$v.formData.phone.$params.minLength.min}} digits!</p> -->

        <span class="input input--nao">
            <input class="input__field input__field--nao" type="text" v-model.trim="$v.formData.subject.$model" placeholder="Subject"/>
            <svg class="graphic graphic--nao" :class="($v.formData.subject.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
            </svg>
        </span>
        <p class="form-error" v-if="$v.formData.subject.$error && !$v.formData.subject.required">Please Enter your subject!</p>

        <span class="input input--nao">
            <textarea class="input__field input__field--nao" v-model.trim="$v.formData.message.$model" placeholder="Write message"></textarea>
            <svg class="graphic graphic--nao" :class="($v.formData.name.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
            </svg>
        </span>
        <p class="form-error" v-if="$v.formData.message.$error && !$v.formData.message.required">Please Enter your message!</p>

        <!--message-area-->
        <div class="d-flex message-button-wrap mt-5 mb-3">
            <div class="subm-btn theme-button aos-init aos-animate" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1300">
                <input type="submit" class="btn contact-btn" value="Send Message">
            </div>
        </div>
        <div class="resMsg"></div>
    </form>
</template>

<script>
import { required, minLength, email, numeric } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            formData: {
                name: '',
                email: '',
                subject: '',
                phone: '',
                message: ''
            }
        }
    },
    validations: {
        formData: {
            name: {
                required,
                minLength: minLength(4)
            },
            email: {required,email},
            phone: {required, numeric},
            subject:{required},
            message: {required}
        }
    },
    methods: {
        contactFormSubmit(){
            this.$v.$touch()
            if(!this.$v.$invalid){
                document.querySelector('.resMsg').style.display = 'block'
                this.$http.post(`/contact`, this.formData )
                .then(res=>{
                    if(typeof res !== 'undefined' && res.status === 200){
                         if(res.data.status === true){
                            document.querySelector('#contact-form').reset()
                            document.querySelector('.resMsg').innerHTML =`<p class="alert alert-success">${res.data.message}</p>`    
                         }                
                        else
                            document.querySelector('.resMsg').innerHTML =`<p class="alert alert-danger">${res.data.error}</p>`
                    }
                    
                }).catch(err => {
                    console.log('err', err);
                    document.querySelector('.resMsg').innerHTML =`<p class="alert alert-danger">Something Went Wrong!</p>`
                })

                this.togellingResponse();
            }
        },
        togellingResponse(){
            setTimeout(()=>{
                document.querySelector('.resMsg').style.display = 'none'
            }, 5000)
        }
    }
}
</script>

<style scoped>
.form-error{
    color: #f00; font-size: 0.7rem;
}
.error-stroke{stroke:#f00;}
.contact-form-wrapper .input--nao {
    margin-bottom: 0;
    padding: 10px 0;
}
</style>